import axios from './axios'

export const getUploadUrl = () => {
    return axios.defaults.baseURL + '/romons.configuration/api/upload'
}

export const getBanner = async () => {
    try {
        return await axios.get(`/romons.configuration/api/banner`)
    } catch (error) {
        console.err(error);
        throw error;
    }
}

export const saveBanner = async (req) => {
    try {
        return await axios.post(`/romons.configuration/api/banner/save`, req)
    } catch (error) {
        console.err(error);
        throw error;
    }
}

export const bannerReorder = async (req) => {
    try {
        return await axios.post(`/romons.configuration/api/banner/reorder`, req)
    } catch (error) {
        console.err(error);
        throw error;
    }
} 